import { JobCardList } from '@components/JobCardList/index';
import React from 'react';

export const HomepageJobs = () => {
  return (
    <div className="rev-o-container">
      <div className="rev-o-grid rev-u-py-40 rev-u-mt-40">
        <div className="rev-o-col-12 rev-u-px-16">
          <JobCardList />
        </div>
      </div>

      <div className="rev-o-grid rev-u-py-40">
        <div className="rev-o-col-12 rev-u-px-16">
          <JobCardList isClosedJobList />
        </div>
      </div>
    </div>
  );
};
